import { render, staticRenderFns } from "./Shbe.vue?vue&type=template&id=10e1bc8e&scoped=true"
import script from "./Shbe.vue?vue&type=script&lang=js"
export * from "./Shbe.vue?vue&type=script&lang=js"
import style0 from "./Shbe.vue?vue&type=style&index=0&id=10e1bc8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e1bc8e",
  null
  
)

export default component.exports